import ReactionModel from '@linc-technologies/linced-common/models/posts/reaction';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Studentnotice from 'linced-learners/models/posts/studentnotice';

// Proto: posts.Reaction.
export default class Reaction extends ReactionModel {
  declare [Type]: 'posts/reaction';

  @belongsTo('posts/studentnotice', { async: true, inverse: 'reactions' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;
}
